import React, {useEffect, useMemo, useState} from "react";
import {css, cx} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {gtmRotatingPhoneNumbersCall} from "../../../tracking/google_tag_manager/gtm_rotating_phone_numbers";
import {useApplicationPhoneClipNumber} from "../../hooks/use_application_phone_clip_number";

interface IProps {
    isAutoresponderEnabled: boolean;
    showSeparatorText: boolean;
    isDataFetched: boolean;
    offer?: IOfferDetailApplication | null;
    propertyId?: number;
    optionalOfferPhoneData?: {
        configuration: {
            phone_clip: string | null;
        };
        is_phone_clip_enabled: boolean;
    };
}

const NO_CONTACT_DATA = "BRAK DANYCH KONTAKTOWYCH";

export const ApplicationFormBoxPhoneNumber = (props: IProps) => {
    const [fetchInitialized, setFetchInitialized] = useState(false);

    const realPhoneNumber =
        (props.offer?.sales_offices.length && props.offer?.sales_offices[0].phone) ||
        (props.offer?.sales_offices.length && props.offer?.sales_offices[0].mobile);
    const fallbackPhoneNumber = useMemo(
        () =>
            (props.optionalOfferPhoneData?.is_phone_clip_enabled && props.optionalOfferPhoneData.configuration.phone_clip) ||
            (props.isDataFetched && props.offer?.is_phone_clip_enabled && props.offer?.configuration.phone_clip) ||
            (props.isDataFetched &&
                props.offer?.sales_offices &&
                props.offer?.sales_offices.length &&
                (props.offer.sales_offices[0].phone || props.offer.sales_offices[0].mobile)) ||
            null,
        [props.optionalOfferPhoneData, props.isDataFetched, props.offer]
    );
    const {phoneNumber: clipPhone, fetchClipPhoneNumber, isFetching, isClipPhoneBlocked} = useApplicationPhoneClipNumber(fallbackPhoneNumber);
    const phoneNumber = isClipPhoneBlocked ? realPhoneNumber : clipPhone;

    useEffect(() => {
        fetchClipPhoneNumber(props.propertyId);
        setFetchInitialized(true);
    }, []);

    return !props.isAutoresponderEnabled ? (
        <>
            {phoneNumber !== null && props.showSeparatorText && (
                <Text align="center" className={separatorTextStyle} color={getThemeVariable("colors.gray.700")} variant="body_copy_2">
                    lub zadzwoń
                </Text>
            )}

            <div className={absoluteCenterWithTopMarginStyle}>
                {isFetching || !fetchInitialized ? (
                    <Loader size="sm" className={cx(topMarginStyle, mutedLoaderStyle)} />
                ) : phoneNumber ? (
                    <div className={columnCenterStyle}>
                        <div className={phoneSectionStyle}>
                            <PhoneIcon size="2.4" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="4" />
                            <Link
                                className={linkStyle}
                                href={`tel:+${phoneNumber}`}
                                onClick={() => {
                                    gtmRotatingPhoneNumbersCall();
                                }}
                            >
                                <Text as="span" variant="headline_6" color={getThemeVariable("colors.secondary")}>
                                    {phoneNumberFormat(phoneNumber)}
                                </Text>
                            </Link>
                        </div>
                    </div>
                ) : (
                    <Text as="span" variant="headline_6" align="center" color={getThemeVariable("colors.secondary")} className={topMarginStyle}>
                        {NO_CONTACT_DATA}
                    </Text>
                )}
            </div>
        </>
    ) : null;
};

const separatorTextStyle = css({
    marginTop: 2
});

const absoluteCenterWithTopMarginStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 2
});

const topMarginStyle = css({
    marginTop: 2
});

const mutedLoaderStyle = css({
    opacity: 0.5
});

const columnCenterStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});

const phoneSectionStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 2
});

const linkStyle = css({
    marginLeft: 2,
    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "none",
        color: "inherit"
    }
});
import React, {useEffect, useMemo, useState} from "react";
import {css, cx} from "@panda/css";

import {PhoneIcon} from "@pg-design/icons-module";
import {Link} from "@pg-design/link-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

import {IOfferDetailApplication} from "../../../offer/types/IOfferDetailApplication";
import {gtmRotatingPhoneNumbersCall} from "../../../tracking/google_tag_manager/gtm_rotating_phone_numbers";
import {useApplicationPhoneClipNumber} from "../../hooks/use_application_phone_clip_number";

interface IProps {
    isAutoresponderEnabled: boolean;
    showSeparatorText: boolean;
    isDataFetched: boolean;
    offer?: IOfferDetailApplication | null;
    propertyId?: number;
    optionalOfferPhoneData?: {
        configuration: {
            phone_clip: string | null;
        };
        is_phone_clip_enabled: boolean;
    };
}

const NO_CONTACT_DATA = "BRAK DANYCH KONTAKTOWYCH";

export const ApplicationFormBoxPhoneNumber = (props: IProps) => {
    const [fetchInitialized, setFetchInitialized] = useState(false);

    const realPhoneNumber =
        (props.offer?.sales_offices.length && props.offer?.sales_offices[0].phone) ||
        (props.offer?.sales_offices.length && props.offer?.sales_offices[0].mobile);
    const fallbackPhoneNumber = useMemo(
        () =>
            (props.optionalOfferPhoneData?.is_phone_clip_enabled && props.optionalOfferPhoneData.configuration.phone_clip) ||
            (props.isDataFetched && props.offer?.is_phone_clip_enabled && props.offer?.configuration.phone_clip) ||
            (props.isDataFetched &&
                props.offer?.sales_offices &&
                props.offer?.sales_offices.length &&
                (props.offer.sales_offices[0].phone || props.offer.sales_offices[0].mobile)) ||
            null,
        [props.optionalOfferPhoneData, props.isDataFetched, props.offer]
    );
    const {phoneNumber: clipPhone, fetchClipPhoneNumber, isFetching, isClipPhoneBlocked} = useApplicationPhoneClipNumber(fallbackPhoneNumber);
    const phoneNumber = isClipPhoneBlocked ? realPhoneNumber : clipPhone;

    useEffect(() => {
        fetchClipPhoneNumber(props.propertyId);
        setFetchInitialized(true);
    }, []);

    return !props.isAutoresponderEnabled ? (
        <>
            {phoneNumber !== null && props.showSeparatorText && (
                <Text align="center" className={separatorTextStyle} color={getThemeVariable("colors.gray.700")} variant="body_copy_2">
                    lub zadzwoń
                </Text>
            )}

            <div className={absoluteCenterWithTopMarginStyle}>
                {isFetching || !fetchInitialized ? (
                    <Loader size="sm" className={cx(topMarginStyle, mutedLoaderStyle)} />
                ) : phoneNumber ? (
                    <div className={columnCenterStyle}>
                        <div className={phoneSectionStyle}>
                            <PhoneIcon size="2.4" wrapperColor={getThemeVariable("colors.primary")} wrapperSize="4" />
                            <Link
                                className={linkStyle}
                                href={`tel:+${phoneNumber}`}
                                onClick={() => {
                                    gtmRotatingPhoneNumbersCall();
                                }}
                            >
                                <Text as="span" variant="headline_6" color={getThemeVariable("colors.secondary")}>
                                    {phoneNumberFormat(phoneNumber)}
                                </Text>
                            </Link>
                        </div>
                    </div>
                ) : (
                    <Text as="span" variant="headline_6" align="center" color={getThemeVariable("colors.secondary")} className={topMarginStyle}>
                        {NO_CONTACT_DATA}
                    </Text>
                )}
            </div>
        </>
    ) : null;
};

const separatorTextStyle = css({
    marginTop: 2
});

const absoluteCenterWithTopMarginStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 2
});

const topMarginStyle = css({
    marginTop: 2
});

const mutedLoaderStyle = css({
    opacity: 0.5
});

const columnCenterStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
});

const phoneSectionStyle = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 2
});

const linkStyle = css({
    marginLeft: 2,
    "&, &:link, &:visited, &:hover, &:active": {
        textDecoration: "none",
        color: "inherit"
    }
});
